module.exports = __webpack_public_path__ + "static/media/fb-cover.820254b5.png";